import { render, staticRenderFns } from "./MallListMenu.vue?vue&type=template&id=7fd54d59&scoped=true&"
import script from "./MallListMenu.vue?vue&type=script&lang=ts&"
export * from "./MallListMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MallListMenu.vue?vue&type=style&index=0&id=7fd54d59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd54d59",
  null
  
)

export default component.exports